module.exports = __webpack_public_path__ + "img/farzana-christopher-37.c6b7cf79.jpg";